export default {
  black: '#17181F',

  white: '#F8F8F2',

  red: '#FF5555',
  green: '#2BC740',
  yellow: '#FFBF32',
  blue: '#87E9FE',
  pink: '#FF76C7',
  transparent: 'transparent',
};
